export const UPDATE_PASSWORD_ERROR = 'need_to_change_password'

export enum TYPE_MCHD {
	SIG = 'mchd_sig',
	XML = 'mchd_xml',
}

export const notificationOptions = [
	{ value: false, label: 'Автоматически', key: 'setting_channel_default' },
	{ value: true, label: 'Вручную', key: 'setting_channel_user' },
]

export enum CHANNEL_ID {
	EMAIL = 1,
	NEO = 2,
}

export const channelFieldNames = {
	[CHANNEL_ID.EMAIL]: 'all_1',
	[CHANNEL_ID.NEO]: 'all_2',
}
